export const twoDecimals = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
export const formatPercentage = (value?: number | null): string => {
  return value != null ? (value * 100).toFixed(2) + "%" : "-";
};
export const formatPercentageNo100 = (value?: number | null): string => {
  return value != null ? (value * 1).toFixed(2) + "%" : "-";
};
export const formatNumber = (value?: number | null): string => {
  return value != null ? value.toFixed(2) : "-";
};
export const formatNumber3 = (value?: number | null): string => {
  return value != null ? value.toFixed(3) : "-";
};
